if (!customElements.get('kelp-calculator')) {
  class KelpCalculator extends HTMLElement {
    connectedCallback() {
      this.plantsInput = this.querySelector('[data-plants-input]');
      this.frequencyInput = this.querySelector('[data-frequency-input]');
      this.button = this.querySelector('[data-calc-button]');
      this.result = this.querySelector('[data-calc-result]');
      this.resultText = this.querySelector('[data-calc-result-text]');
      this.loader = this.querySelector('[data-calc-loader]');
      this.plantsError = this.querySelector('[data-plants-error]');
      this.frequencyError = this.querySelector('[data-frequency-error]');
      this.loadingTimeout = null;

      // Strip hidden so CSS transitions can control visibility
      if (this.plantsError) this.plantsError.removeAttribute('hidden');
      if (this.frequencyError) this.frequencyError.removeAttribute('hidden');

      if (!this.button || !this.plantsInput || !this.frequencyInput) return;

      this.button.addEventListener('click', () => this.calculate());
      this.plantsInput.addEventListener('input', () => this.handleFieldChange());
      this.frequencyInput.addEventListener('change', () => this.handleFieldChange());
    }

    handleFieldChange() {
      this.validateInputs(false);
      this.updateIfVisible();
    }

    updateIfVisible() {
      if (this.result && !this.result.hidden) this.calculate();
    }

    calculate() {
      const dilution = Number(this.dataset.dilution || 10);
      const gallonsPerPlant = Number(this.dataset.gallons || 0.5);
      const weeksPerYear = Number(this.dataset.weeks || 52);

      clearTimeout(this.loadingTimeout);

      const { plants, frequency, isValid } = this.validateInputs(true);

      if (!isValid) {
        this.setLoading(false);
        this.showMessage('Please complete all required fields.', true);
        return;
      }

      const annualUsage = dilution * gallonsPerPlant * frequency * plants * weeksPerYear;
      const formattedMl = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 2,
      }).format(annualUsage);

      this.setLoading(true);
      this.loadingTimeout = setTimeout(() => {
        this.setLoading(false);
        this.showMessage(formattedMl, false);
      }, 700);
    }

    validateInputs(showErrors) {
      const plants = Number(this.plantsInput.value);
      const frequency = Number(this.frequencyInput.value);
      const isPlantsValid = Number.isFinite(plants) && plants > 0;
      const isFrequencyValid = Number.isFinite(frequency) && frequency > 0;

      this.toggleFieldError(this.plantsInput, this.plantsError, !isPlantsValid && showErrors);
      this.toggleFieldError(this.frequencyInput, this.frequencyError, !isFrequencyValid && showErrors);

      return {
        plants,
        frequency,
        isValid: isPlantsValid && isFrequencyValid,
      };
    }

    toggleFieldError(input, message, showError) {
      if (!input) return;

      input.classList.toggle('is-invalid', showError);
      input.setAttribute('aria-invalid', showError ? 'true' : 'false');

      if (message) {
        message.classList.toggle('is-visible', showError);
      }
    }

    setLoading(isLoading) {
      if (!this.result) return;

      this.result.classList.toggle('is-loading', isLoading);

      if (this.loader) {
        this.loader.hidden = !isLoading;
      }

      if (this.button) {
        this.button.disabled = isLoading;
      }
    }

    showMessage(value, isError = false) {
      if (!this.result || !this.resultText) return;

      const hasValue = Boolean(value) && !isError;

      this.result.classList.toggle('is-error', isError);
      this.result.classList.toggle('has-value', hasValue);
      this.resultText.textContent = value;
    }
  }

  customElements.define('kelp-calculator', KelpCalculator);
}
